import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("aqua_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("aqua_token");
      localStorage.removeItem("aqua_user");
      // Don't hard-redirect. Let React Router + AuthProvider handle navigation
      // so that on-refresh flows (like /admin) don't loop through a full reload.
    }
    return Promise.reject(err);
  }
);

export default client;
